import EventPublisher from "../utils/EventPublisher";
import UIInteractionEvents from "../constants/events/UIInteractionEvents";
import SpaceReservationAPIClient from "../client/SpaceReservationAPIClient";
import AdvertisementAPIClient from "../client/AdvertisementAPIClient";
import SpaceAPIClient from "../client/SpaceAPIClient";

class ProfileActions {

    constructor() {
        this.spaceApiClient = new SpaceAPIClient();
        this.spaceReservationAPIClient = new SpaceReservationAPIClient();
        this.advertiserAPIClient = new AdvertisementAPIClient();
        EventPublisher.subscribe(UIInteractionEvents.RENDERED_VIEW_REQUIRES_MEMBER_SPACE_CALENDAR, this.handleMemberCalendarRequired);
        EventPublisher.subscribe(UIInteractionEvents.BLOCK_ALL_MEMBER_SPACE_CALENDAR_CLICKED, this.handleBlockAllSpaceCalendar);
        EventPublisher.subscribe(UIInteractionEvents.UNBLOCK_ALL_MEMBER_SPACE_CALENDAR_CLICKED, this.handleUnlockAllSpaceCalendar);
        EventPublisher.subscribe(UIInteractionEvents.BLOCK_DATES_MEMBER_SPACE_CALENDAR_CLICKED, this.handleBlockRangeSpaceCalendar);
        EventPublisher.subscribe(UIInteractionEvents.UNBLOCK_DATES_MEMBER_SPACE_CALENDAR_CLICKED, this.handleUnblockRangeSpaceCalendar);
        EventPublisher.subscribe(UIInteractionEvents.PRIVATE_SPACE_DETAILS_SET_SPACE_ID, this.handleGetPrivateSpaceDetails);
        EventPublisher.subscribe(UIInteractionEvents.PRIVATE_SPACE_DETAILS_RESERVATION_REQUEST_CLICKED, this.handleCreateSpaceReservationRequest);
    }

    handleCreateSpaceReservationRequest = (topic, data) => {
        this.spaceReservationAPIClient.createReservationRequest(
            data.spaceId,
            data.advertisementId,
            data.startDate,
            data.endDate);
    };

    handleGetPrivateSpaceDetails = (topic, data) => {
        this.spaceApiClient.getPrivateSpaceDetails(data.id);
        this.spaceReservationAPIClient.getUnavailbleSpaceCalendar(data.id);
        this.advertiserAPIClient.getMyAdvertisements();
    };


    handleMemberCalendarRequired = (topic, data) => {
        this.spaceReservationAPIClient.getMemberSpaceCalendar(data.spaceId);
    };

    handleBlockAllSpaceCalendar = (topic, data) => {
        this.spaceReservationAPIClient.blockAllAvailableSpaceCalendarDates(data.spaceId);
    };

    handleUnlockAllSpaceCalendar = (topic, data) => {
        this.spaceReservationAPIClient.unblockAllSpaceCalendarDates(data.spaceId);
    };

    handleBlockRangeSpaceCalendar = (topic, data) => {
        this.spaceReservationAPIClient.blockSpaceCalendarDates(data.spaceId, data.startDate, data.endDate);
    };

    handleUnblockRangeSpaceCalendar = (topic, data) => {
        this.spaceReservationAPIClient.unblockSpaceCalendarDates(data.spaceId, data.startDate, data.endDate);
    };


}

export default new ProfileActions();
